import React from 'react';
import type { Event, EventHeroProps } from '../../../types/index';
import './HeroImage.scss';

export type HeroImageProps = {
    eventName: Event['name'];
    background?: string;
} & Pick<
    EventHeroProps,
    | 'croppedLogoUrl480'
    | 'croppedLogoUrl600'
    | 'croppedLogoUrl800'
    | 'croppedLogoUrl940'
> &
    Pick<Event, 'hasCroppedLogo'>;

export const HeroImage = ({
    background,
    hasCroppedLogo,
    croppedLogoUrl480,
    croppedLogoUrl600,
    croppedLogoUrl800,
    croppedLogoUrl940,
    eventName,
}: HeroImageProps) => {
    const Image = () => {
        return (
            <div className="hero-image-wrapper">
                <div className="hero-image fx--delay-6 fx--fade-in">
                    <div
                        className="hero-image__background"
                        style={{ backgroundImage: `url("${background}")` }}
                    />
                    <picture>
                        <source
                            srcSet={`
                                ${croppedLogoUrl480} 480w,
                                ${croppedLogoUrl600} 600w,
                                ${
                                    croppedLogoUrl940
                                        ? `${croppedLogoUrl940} 940w`
                                        : `${croppedLogoUrl800} 800w`
                                }
                            `}
                            sizes={`
                                (max-width:480px) 480px,
                                (max-width:600px) 600px,
                                ${croppedLogoUrl940 ? '940px' : '800px'}
                            `}
                        />
                        <img
                            width="600"
                            height="300"
                            alt={eventName}
                            src={croppedLogoUrl600}
                        />
                    </picture>
                </div>
            </div>
        );
    };

    return <>{hasCroppedLogo && <Image />}</>;
};
